import { render, staticRenderFns } from "./HolidaysChildrenPlans.vue?vue&type=template&id=8c3345b6&"
import script from "./HolidaysChildrenPlans.vue?vue&type=script&lang=js&"
export * from "./HolidaysChildrenPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports